import { useVisualEffectsContext } from '@/context/VisualEffectsContext';
import type { VisualEffectsContextValue } from '@/types/visualEffects';

/**
 * Hook to access visual effects state and controls.
 *
 * @example
 * ```tsx
 * const { getPageConfig, triggerState, isShabbat } = useVisualEffects();
 *
 * // Get config for a page
 * const studyConfig = getPageConfig('study');
 *
 * // Trigger celebration effect
 * triggerState('celebration', 3000);
 * ```
 */
export function useVisualEffects(): VisualEffectsContextValue {
  return useVisualEffectsContext();
}
